import React from "react";
import { Form, FormControl, InputGroup } from "react-bootstrap";
import { useField } from "formik";

const BInputGroupField = ({
    controlId,
    onClick,
    appendStart,
    icon,
    type,
    label,
    Avatar,
    serverError,
    formMargin,
    ...props
}) => {
    const [field, meta] = useField(props);
    // const cancelPasting = (e) => {
    //     if (type === 'password') {
    //         e.preventDefault()
    //     }
    // }

    return (
        <div className={formMargin}>
            <Form.Label>{label}</Form.Label>
            <InputGroup>
                {appendStart && (
                    <InputGroup.Prepend>
                        <InputGroup.Text id={controlId} onClick={onClick} className="theme-icon">
                            {Avatar ? <span>{Avatar}</span> : icon}
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                )}
                <FormControl
                    {...field}
                    {...props}
                    type={type}
                    isInvalid={meta.error && meta.touched}
                    isValid={!meta.error && meta.touched}
                    // onPaste={type==="password"?(e) => cancelPasting(e):null}
                    aria-label={props.name}
                    // aria-describedby="basic-addon1"
                />
                {!appendStart && (
                    <InputGroup.Prepend>
                        <InputGroup.Text id={controlId} onClick={onClick} className="theme-icon">
                            {Avatar ? <span>{Avatar}</span> : icon}
                        </InputGroup.Text>
                    </InputGroup.Prepend>
                )}
                {meta.error && meta.touched ? (
                    <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                ) : null}
            </InputGroup>
            {serverError ? (
                <small className="text-danger" style={{ margin: 0, padding: 0 }}>
                    {serverError}
                </small>
            ) : null}
        </div>
    );
};

BInputGroupField.defaultProps = {
    Avatar: "",
    appendStart: true,
    disabled: false,
    maxLength: 255,
    serverError: null,
    size: "md",
    type: "text",
    icon: null,
    onClick: null,
    formMargin: "mb-4"
};

export default BInputGroupField;
